import React from 'react';
import { Pagetitle } from '@ktag/styleguide/dist/react';
import { useTranslation } from 'react-i18next';
import EditProgress from './EditProgress';
import EditInfoBox from './EditInfoBox';

const EditTimeout = () => {
  const { t } = useTranslation('newsletter');

  return (
    <div className="edit richtext">
      <Pagetitle additionalClassNames="edit__header">{t('edit_header')}</Pagetitle>
      <EditProgress editStep={3} isSuccess={false} />
      <EditInfoBox editStep={3} isSuccess={false} isTimeout />
    </div>
  );
};

export default EditTimeout;
